export const VALIDATE_EMAIL = "email/validate";
export const VALIDATE_EMAIL_DONE = "email/validate_done";
export const VALIDATE_EMAIL_FAILED = "email/validate_failed";